<div class="adv_wrapper">

    <div>
        <a target="_blank" (click)="addClick()" [href]="adv.link">
            <img id="card_video"  [alt]="adv.text" loading="lazy"  />
                <!-- <iframe scrolling="no" class="card_video" frameBorder="0"
                    src="../../../../assets/images/advs/9/ezer_mezion320X180.html"></iframe>
                <span style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 10;"></span> -->

        </a>
        <div class="card_details">
            <a [href]="adv.link" (click)="addClick()">
                <h2 class="card_title">{{adv.text}}</h2>
            </a>
            <div class="card_details_line">
                <h3>תוכן מקודם</h3>
            </div>
        </div>

    </div>
</div>